import React from 'react';
import Report from '../../components/Report/Report';

const QuickReport = ({ fullscreen, setFullscreen }) => {
  return <Report fullscreen={fullscreen} setFullscreen={setFullscreen} type="Quick Report" />;
};

export default QuickReport;
